import React, { PropTypes } from 'react';
import { connect } from 'react-redux';


export function SignInLink() {
  return (
    <div>
      <a className='btn btn-lg btn-block btn-success'>Login</a>
    </div>
  )
}

export default SignInLink



// WEBPACK FOOTER //
// ./src/views/components/SignInLink/index.js